<app-dialog
  [title]="data.title"
  [actions]="actions"
  [description]="data.title === 'Create Shipment' ? description : ''"
  (action)="dialogAction($event)"
  (close)="close()"
>
  <mat-dialog-content>
    <div class="plan-shipment">
      <form
        [ngClass]="{
          'plan-shipment_form': !data.isDraft,
          'plan-shipment_create': data.isDraft
        }"
        [formGroup]="planShipmentForm"
        *ngIf="!shipmentPlan"
      >
        <div class="input-container input-container--fullWidth">
          <label
            for=""
            class="input-container_label"
            [ngClass]="{
              'control-label': data.isDraft,
              'font-600': data.isDraft
            }"
            >Shipment Type</label
          >
          <select
            name=""
            id=""
            class="input-container_input input-container_input--select"
            formControlName="ShipmentType"
          >
            <option *ngFor="let type of fbaTypes" [value]="type.id">{{type.name}}</option>
          </select>
        </div>

        <div class="input-container input-container--fullWidth">
          <div class="d-flex justify-content-between">
            <label
              for=""
              class="input-container_label"
              [ngClass]="{
                'control-label': data.isDraft,
                'font-600': data.isDraft
              }"
              >From Warehouse</label
            >
            <app-button
              *ngIf="!warehouseExists"
              [buttonStyle]="'text underline'"
              [buttonSize]="'action'"
              [buttonColor]="'primary'"
              (click)="createNewWarehouse('New')"
              >Create New</app-button
            >
          </div>
          <select
            name=""
            id=""
            class="input-container_input input-container_input--select"
            formControlName="fromWareHouseId"
          >
            <option
              *ngFor="let warehouse of data.warehouses$ | async"
              [value]="warehouse.id"
            >
              {{ warehouse.id }}
            </option>           
          </select>
        </div>

        <ng-container *ngIf="!data.isDraft" formArrayName="skus">
          <div
            class="sku-inputs"
            *ngFor="let skill of skus.controls; index as i"
            [formGroupName]="i"
          >
            <div class="input-wrapper">
              <div class="input-container input-container--fullWidth">
                <label for="" class="input-container_label" *ngIf="i == 0"
                  >SKU</label
                >
                <input
                  type="text"
                  class="input-container_input"
                  [ngClass]="{
                    'invalid-search':
                      filteredOptionsArray[i].length === 0 &&
                      planShipmentForm.get('skus.' + i + '.sku').touched
                  }"
                  formControlName="sku"
                  placeholder="Search"
                  [matAutocomplete]="auto"
                />
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option
                    *ngFor="let option of filteredOptionsArray[i] | async"
                    [value]="option.sku"
                    class="mat-option-override"
                  >
                    <app-item-typeahead
                            [name]="option.title"
                            [sku]="option.sku"
                            [asin]="option.asin"
                            [image]="option.imageUrl"
                    ></app-item-typeahead>
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="input-container input-container--qty">
                <label for="" class="input-container_label" *ngIf="i == 0"
                  >Quantity</label
                >
                <input
                  type="number"
                  class="input-container_input"
                  formControlName="qty"
                  min="0"
                  (keypress)="restrictNumeric($event)"
                />
              </div>
              <div
                [ngClass]="{ 'first-child': i == 0 }"
                class="sku-inputs_icon"
                matTooltip="Remove row"
                *ngIf="skus.controls.length > 1"
                (click)="removeSkuToForm(i)"
              >
                <i class="fal fa-times"></i>
              </div>
            </div>
          </div>
          <div class="text-center sku-inputs_add-btn">
            <app-button
              [buttonSize]="'action'"
              [buttonStyle]="'text'"
              (click)="addSkuToForm(skus.controls.length)"
              >Add Row</app-button
            >
          </div>
        </ng-container>
      </form>
      <div *ngIf="data.isDraft">
        <div class="plan-shipment_header-title">
          <h5>Selected SKUs</h5>
        </div>
        <div class="plan-shipment_search">
          <div class="plan-shipment_search-icon">
            <i
              class="fal"
              (click)="clearSearch()"
              [ngClass]="{
                'fa-search': !searchInput.value,
                'fa-times': searchInput.value
              }"
            ></i>
          </div>
          <input
            type="text"
            class="plan-shipment_input"
            placeholder="Search"
            [formControl]="searchInput"
          />
          <app-button
            class="plan-shipment_text"
            (click)="importBulk()"
            [buttonStyle]="'text'"
            [buttonSize]="'action'"
            [buttonColor]="'primary'"
            >Import Bulk</app-button
          >
        </div>
        <div class="plan-shipment_sku-list">
          <app-plan-shipment-sku
            *ngFor="let item of addToShipmentSkus$ | async"
            [data]="item"
            [formvalue]="planShipmentForm"
            (itemSelectedEvent)="deleteItem($event)"
          ></app-plan-shipment-sku>
          <app-plan-shipment-sku
            *ngFor="let item of selectedSKUs"
            [data]="item"
            [formvalue]="planShipmentForm"
            (itemSelectedEvent)="deleteItem($event)"
          ></app-plan-shipment-sku>
          <app-search-add-plan-shipment-sku
            [formvalue]="planShipmentForm"
            [data]="skusToAddToShipment"
            (itemSelectedEvent)="loadSku($event)"
          ></app-search-add-plan-shipment-sku>
        </div>
      </div>
      <div *ngIf="shipmentPlan?.length" class="plan-shipment_result">
        <app-shipment-plan-item
          [plan]="plan"
          *ngFor="let plan of shipmentPlan"
        ></app-shipment-plan-item>
        <div class="note">
          Shipment plans are saved for 48 hours. You can confirm the shipment
          now, replan, or you can confirm this shipment plan when merging a
          shipment
        </div>
      </div>
    </div>
  </mat-dialog-content>
</app-dialog>
